// RetryManager.js
// Manages queued requests and retries
export default class RetryManager {
  constructor(apiService) {
    this.apiService = apiService;
    this.queue = [];
    this.maxRetries = 3;
  }
  queueRequest({ config, key, tracker, metaObj }) {
    this.queue.push({ config, key, tracker, metaObj, retries: 0 });
  }
  retryAll() {
    const toRetry = [...this.queue];
    this.queue = [];
    toRetry.forEach(({ config, key, tracker, metaObj }) => {
      if (metaObj.retries < this.maxRetries) {
        metaObj.retries++;
        metaObj.status = 'retry';
        this.apiService._sendRequest({ config, key, tracker, metaObj });
      } else {
        metaObj.status = 'failed';
        tracker.markComplete('failed');
        this.apiService.emit('status', { key, meta: metaObj });
      }
    });
  }
  removeRequest(key) {
    this.queue = this.queue.filter(req => req.key !== key);
  }
  clearAll() {
    this.queue = [];
  }
}
